"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var resource_1 = require("../shared/resource");
var LocationOwner = /** @class */ (function (_super) {
    __extends(LocationOwner, _super);
    function LocationOwner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationOwner.prototype.url = function (action) {
        return '/location_owners/' + this.id + '/' + action;
    };
    LocationOwner.prototype.filterOptions = function (options) {
        options = lodash_1.clone(options);
        return options;
    };
    return LocationOwner;
}(resource_1.Resource));
exports.LocationOwner = LocationOwner;
